const keyValueMapping = {
    OUT_OF_NETWORK: 'Out Of Network',
    XXIV_HOUR_CONFIRMED: '24 Hour Confirmed'
};
Object.freeze(keyValueMapping);
export default keyValueMapping;